const nl = {
    'actions': {
        'add': 'Toevoegen',
        'addaccount': 'Account aanvragen',
        'back': 'Terug',
        'backtoadmin': 'Terug naar beheer',
        'createuser': 'Maak gebruiker',
        'close': 'Sluiten',
        'delete': 'Verwijderen',
        'download': 'Downloaden',
        'edit': 'Bewerken',
        'export': 'Exporteren',
        'impersonate': 'Inloggen&nbsp;als',
        'sendinvite': 'Uitnodiging&nbsp;sturen',
        'login': 'Inloggen',
        'logout': 'Uitloggen',
        'next': 'Volgende',
        'previous': 'Vorige',
        'ok': 'Ok',
        'save': 'Opslaan',
        'search': 'Zoeken',
        'submit': 'Versturen',
        'returntologin': 'Terug naar login',
        'resetuser': 'Uitnodiging sturen',
        'refresh':'Vernieuwen',
        'syncmessages': 'Berichten synchroniseren',
        'synccompany': 'Accounts synchroniseren',
        'synccompanymessages': 'Bedrijfsberichten synchroniseren',
        'syncworker': 'Synchronisatieclients',
        'syncworkermessages':'Berichten van de synchronisatieclient'
    },
    'confirm': {
        'leaveWithoutSave': '<strong>Weet u zeker dat u deze pagina wilt verlaten?</strong><br />Er zijn wijzigingen die nog niet zijn opgeslagen',
        'delete': '<strong>Weet u het zeker?</strong><br />De gegevens worden definitief verwijderd',
        'changerole': '<strong>Weet u het zeker?</strong><br />De rol van deze gebruiker wordt gewijzigd',
        'archive': '<strong>Weet u het zeker?</strong><br />De gegevens worden gearchiveerd',
    },
    'error': {
        'saveChanges': 'Er is een probleem opgetreden tijdens het opslaan van de gegevens',
        'deleteRecordConflict': 'Dit record kan niet worden verwijderd',
        'emailexists': 'Dit e-mailadres is al in gebruik',
        'emailnotfound': 'E-mail niet gevonden. Neem contact op met Telefoonaanname',
        'exporttoexcel': 'Fout tijdens het exporteren van bestand',
        'fetch': 'Fout terwijl u gegevens ophaalt',
    },
    'format': {
        'dateo': 'D MMMM YYYY',
        'date': 'dd D MMMM YYYY',
        'dateTime': 'dd D MMMM YYYY HH:mm',
        'fullDate': 'LLLL',
        'time': 'HH:mm',
        'timezone': 'UTC'
    },
    'salutation': {
        'M': 'De heer',
        'F': 'Mevrouw',
        'V': 'Mevrouw'
    },
    'gen': {
        'M': 'Man',
        'F': 'Vrouw',
        'V': 'Vrouw'
    },
    'intervalType': {
        'daily': 'Dagelijks',
        'weekly': 'Wekelijks',
        'twoWeekEven': 'Tweewekelijks ( even weken )',
        'twoWeekOdd':'Tweewekelijks ( oneven weken )'
    },
    'path': {
        'alert': '/alert',
        'home': '/',
        'login': '/login',
        'forgotpassword': '/login/wachtwoordvergeten',
        'setpassword': '/wijzigwachtwoord',
        'companies': '/relatie',
        'feedback': '/feedback',
        'workers': 'medewerkers',
        'message': '/berichten',
        'invoice': '/factuur',
        'staffmembers': '/personeel',
        'staffmembersExport': '/export',
        'worker': '/medewerker',
        'workerinstruction': '/werkinstructie',
        'workercompany': '/werkmaatschappij',
        'workeralert': '/alertmedewerker',
        'log': '/logboek',
        'manage_administrator': '/beheren/beheerder',
        'validateaccount': '/aanmelden',
        'manage_unemployementhistory': '/uitdienstgeschiedenis',
        'workerparttime': '/partimedag',
        'enum': '/beheren/opties',
        'sync':'/synchroniseren'
    },
    'periods': {
        'short': {
            'sunday': 'Zo',
            'monday': 'Ma',
            'tuesday': 'Di',
            'wednesday': 'Wo',
            'thursday': 'Do',
            'friday': 'Vr',
            'saturday': 'Za',
            'january': 'Jan',
            'february': 'Feb',
            'march': 'Maa',
            'april': 'Apr',
            'may': 'Mei',
            'june': 'Jun',
            'july': 'Jul',
            'august': 'Aug',
            'september': 'Sep',
            'october': 'Okt',
            'november': 'Nov',
            'december': 'Dec',
        },
        'long': {
            'january': 'Januari',
            'february': 'Februari',
            'march': 'Maart',
            'april': 'April',
            'may': 'Mei',
            'june': 'Juni',
            'july': 'Juli',
            'august': 'Augustus',
            'september': 'September',
            'october': 'Oktober',
            'november': 'November',
            'december': 'December',
            'sunday': 'Zondag',
            'monday': 'Maandag',
            'tuesday': 'Dinsdag',
            'wednesday': 'Woensdag',
            'thursday': 'Donderdag',
            'friday': 'Vrijdag',
            'saturday': 'Zaterdag',
        },
        'week': 'Week',
        'month': 'Maand'
    },
    'status': {
        'status': 'Status',
        'loading': 'Laden...',
        'norecords': 'Geen gegevens gevonden',
        'loginfailed': 'Ongeldige combinatie van e-mailadres en wachtwoord',
        'invalidpassword': 'Het wachtwoord is ongeldig',
        'tokenexpired': 'Uw token voor het opnieuw instellen van uw wachtwoord is verlopen',
    },
    'success': {
        'saveChanges': 'De gegevens zijn succesvol opgeslagen',
        'deleteRecord': 'De gegevens zijn succesvol verwijderd',
        'updatepassword': 'Uw wachtwoord is ingesteld. U kunt nu inloggen',
        'resetpassword': 'Reset wachtwoordlink verzonden naar uw e-mailadres!',
        'sentmail': 'Mail succesvol verzonden!',
        'forgotpassword': 'U ontvangt binnen enkele minuten een e-mail met enn link om een nieuw wachtwoord in te stellen.',
        'usercreated': 'Account succesvol aangemaakt'
    },
    'subtitle': {
        'forgotpassword': 'Voer hier uw e-mailadres in. U ontvangt daarna een e-mail om een nieuw wachtwoord in te stellen.'
    },
    'title': {
        'administrator': 'Beheerders',
        'alert': 'Alert',
        'home': 'Home',
        'portal': 'Klantenportaal',
        'setpassword': 'Stel een wachtwoord in',
        'updatepassword': 'Wijzig wachtwoord',
        'testenvironment': 'TESTVERSIE',
        'feedback': 'Feedback',
        'profile': 'Profiel',
        'login': 'Login',
        'emailsent': 'E-Mail VERZONDEN',
        'companies': 'Relaties',
        'companiesmenu': 'Bedrijfsaccount',
        'workers': 'Medewerkers',
        'workerparttime': 'Parttimedag',
        'message': 'Berichten',
        'mymessage': 'Mijn berichten',
        'allmessage': 'Alle berichten',
        'invoice': 'Facturen',
        'worker': 'Medewerker',
        'workerinstruction': 'Afwezigheid doorgeven',        
        'companyinstruction': 'Bedrijfsinstructie',
        'termination': 'Medewerker verwijderen of uit dienst melden',
        'log': 'Logboek',
        'createaccount': 'Voer hier uw e-mailadres in. Indien uw gegevens bij ons bekend zijn, ontvangt u een e-mail waarmee u een wachtwoord kunt aanmaken.',
        'unemploymenthistory': 'Uit dienst log',
        'enums': 'Instellingen',
        'myaccount': 'Mijnaccount',
        'sync':'Gegevens syncroniseren'
    },
    'form': {
        'profile': 'Profiel bewerken',
    },
    'warnings': {

    },
    'access': 'Toegang',
    'account': 'Account',
    'accounts': 'Gebruikers zonder account',
    'active': 'Actief',
    'additionaldata': 'Aanvullende gegevens',
    'address': 'Adres',
    'administrator': 'Beheerder',
    'alert': 'Alert',
    'alertdescription': 'Van de box \'Alert\' maakt u geen actief gebruik. Deze wordt door telefoonaanname.nl gebruikt als er sprake is van een spoedeisende calamiteit waardoor wij onze diensten niet kunnen uitvoeren, zoals bijvoorbeeld een stroom- of internetstoring. Alle klanten kunnen dan in één keer gewaarschuwd worden.',
    'all': 'Alle',
    'amount': 'Bedrag',
    'and': 'en',
    'archived': 'Gearchiveerd',
    'banknumber': 'Banknummer',
    'blocked': 'Geblokkeerd',
    'buycredits': 'Vacaturebundel',
    'changepassword': 'Wachtwoord wijzigen',
    'city': 'Plaats',
    'code': 'Code',
    'company': 'Relatie',
    'companyactivity': 'Bedrijfsactiviteit',
    'companydetail': 'Bedrijfsdetail',
    'companyinstruction': 'Bedrijfsinstructie',
    'confirmpassword': 'Bevestig wachtwoord',
    'content': 'Inhoud',
    'count': 'Aantal',
    'country': 'Land',
    'currentpassword': 'Huidig wachtwoord',
    'date': 'Datum',
    'dateend': 'Einddatum',
    'dateendinstru': 'Weerterug',
    'dateexpiration': 'Vervaldatum',
    'dateofbirth': 'Geboortedatum',
    'dateoftermination': 'Datum van beëindiging',
    'datestart': 'Startdatum',
    'datestartinstru': 'Startafwezigheid',
    'day': 'Dag | Dagen',
    'deleted': 'Verwijderd',
    'description': 'Omschrijving',
    'download': 'Download',
    'downloadfile': 'Downloadbestand',
    'email': 'E-mail',
    'emailaddress': 'E-mailadres',
    'endtime': 'Eindtijd',
    'enums': 'Instellingen',
    'executiontype': 'Uitvoeringstype',
    'exportmessage': 'Berichtenexporteren',
    'externalid': 'ExterneId',
    'feedback': 'Feedback',
    'feedbackinstruction': 'Heeft u vragen of opmerkingen over ons klantenportaal? Laat het ons dan weten via onderstaand formulier.',
    'feedbacklabel': 'Versturen',
    'firstname': 'Voornaam',
    'forgotpassword': 'Wachtwoord vergeten?',
    'from': 'Van',
    'function': 'Functie',
    'gender': 'Geslacht',
    'general': 'Algemeen',
    'iban': 'IBAN',
    'inbox': 'Postvak IN',
    'initials': 'Voorletters',
    'instructions': 'Afwezigheid doorgeven',
    'instructionsmain': 'Uw status is opgeslagen als niet bereikbaar tot het einde van de dag.',
    'instructionssub': 'AANVULLENDE INSTRUCTIES',
    'intervalTypelabel': 'Interval',
    'invoice': 'Facturen',
    'invoiceno': 'Factuurnr.',
    'isarchived': 'Is gearchiveerd',
    'jobid': 'Vacature-ID',
    'labeltitle': 'Titel',
    'language': 'Taal',
    'lastchangeexternal': 'Laatste wijziging extern',
    'lastname': 'Achternaam',
    'log': 'Logboek',
    'manual': 'Handleiding',
    'markasunread': 'Markeren als ongelezen',
    'messageapp': 'App',
    'messageemail': 'E-Mail',
    'messageparttime': 'Boodschap aan telefoniste',
    'messages': 'Berichten',
    'messagesms': 'SMS Hier zijn extra kosten aan verbonden; (maximaal 160 tekens per bericht).',
    'middlename': 'Tussenvoegsel',
    'mobile': 'Mobielnummer',
    'month': 'Maand|Maanden',
    'moredetail': 'Meer details',
    'name': 'Naam',
    'newpassword': 'Nieuw wachtwoord',
    'no': 'Nee',
    'none': 'Geen',
    'number': 'Nummer',
    'option': 'Optie',
    'optional': '(OPTIONEEL)',
    'organization': 'Organisatie',
    'password': 'Wachtwoord',
    'passwordRequirements': 'Het wachtwoord dient minimaal 6 tekens lang te zijn en minimaal: 1 hoofdletter, 1 kleine letter, 1 getal en een speciaal teken (b.v. ! @ # $ % ^ & * _ -) te bevatten.',
    'payment': 'Betaling',
    'paymenttype': 'Betalingswijze',
    'pdf': 'PDF',
    'phone': 'Telefoon',
    'phoneforwardingnumber': 'Doorverbindnummer',
    'postaladdress': 'Postadres',
    'postalcode': 'Postcode',
    'public': 'openbaar',
    'purposeofleaveenum': 'Toelichting',
    'quantity': 'Aantal',
    'reasonofabsence': 'Valluik reden afwezigheid',
    'receivemessagevia': 'Berichten ontvangen via',
    'recipient': 'Ontvanger',
    'reference': 'Referentie',
    'referencecustomer': 'Referentieklant',
    'remarks': 'Opmerkingen',
    'role': 'Rol',
    'senderaddress': 'Zender adres',
    'sendercompany': 'Afzender bedrijf',
    'senderemail': 'E-mailadres',
    'sendername': 'Naam afzender',
    'senderphone': 'Telefoon',
    'sendinvitation': 'Stuur uitnodigingsmail',
    'sendpassword': 'Verstuur e-mail',
    'setpassword': 'Stel een wachtwoord in',
    'settings': 'Instellingen',
    'setupaccount': 'ACCOUNT INSTELLEN',
    'scheduled': 'Gepland',
    'staffmembers': 'Medewerkers',
    'starttime': 'Starttijd',
    'street': 'Straat',
    'streetnumber': 'Huisnummer',
    'subtotal': 'Subtotaal',
    'sync': 'Synchroniseren',
    'telephone1': 'Telefoonnummer privé',
    'telephone2': 'Telefoonnummer mobiel',
    'terminationdescription': 'Geef hier de datum uitdiensttreding op. De medewerker zal uit het klantenportaal worden verwijderd als de opgegeven datum is verstreken.',
    'to': 'Aan',
    'total': 'Totaal',
    'totalexlvat': 'Totaal excl. BTW',
    'totalinclvat': 'Totaal',
    'totalvat': 'BTW',
    'type': 'Soort',
    'unemploymenthistory': 'Uit dienst log',
    'upto': 't/m',
    'uptoandincluding': 'Tot en met',
    'user': 'Gebruiker',
    'username': 'E-mailadres',
    'vatnumber': 'BTWnummer',
    'view': 'Weergave',
    'visitingaddress': 'Bezoekadres',
    'warning': 'Waarschuwing',
    'website': 'Website',
    'worker': 'Medewerkers',
    'WorkerAdmin': 'Beheerder',
    'workerdetail': 'Account',
    'workerinstruction': 'Afwezigheid Doorgeven',
    'workerinstructionmessage': 'Vul hier een eventuele reden van afwezigheid in',
    'workerparttime': 'Mijn Parttime dag',
    'workers': 'Gebruikers',
    'WorkerUser': 'Gebruiker',
    'year': 'Jaar',
    'yes': 'Ja',
    'zipcode': 'Postcode'
};

export default nl;